import candidateApi from '~/clientApis/candidateApi';
import { Candidate } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';
import { showMessageModal } from '~/clientUtils/showMessageModal';

export const getCandidateListByRegionId = async (regionId: string): Promise<void> => {
    const candidateStore = getStore().candidateStore;

    candidateStore.setIsLoadingCandidateList(true);

    try {
        const list = await candidateApi.getCandidateList(regionId);

        const processedCandidates: Candidate[] = list.map((c) => {
            return {
                id: c.id,
                firstName: c.candidate_first_name,
                lastName: c.candidate_last_name,
                occupation: c.candidate_job_position,
                preCumulated: c.candidate_cumulation.toString(),
                ballotNumber: c.candidate_priority,
                picture: c.picture,
                postNumber: c.candidate_post_code,
                city: c.candidate_city,
                gender: c.candidate_gender,
                dateOfBirth: c.candidate_date_of_birth,
                case: c.candidate_slogan,
                description: c.candidate_description,
                isConsentReceived: c.candidate_consent,
            };
        });

        processedCandidates.sort(candidateStore.sortCandidates);

        candidateStore.setCandidates(processedCandidates);
    } catch (error) {
        showMessageModal('error', 'Error fetching candidate list');
        throw error;
    } finally {
        candidateStore.setIsLoadingCandidateList(false);
    }
};
